import {ListRequestBody, MultiselectItem, PossibleActions, State} from "./admin.interface";
import {Address, BaseDto, InObj} from "./common.interface";
import {asDate, isNonEmptyArray, isNonNull, isNonNullNumber, isNonNullObject} from "../classes/Utils";
import {Upload} from "./media.interface";
import {SpecificationsBuyer} from "./specifications.interface";

export enum NameListAction {
    NEW_NOMINATIVE = "newNominative",
    EDIT_NOMINATIVE = "editNominative"
}

export enum NominativeContactActions {
    UPDATE_CONTACT_INFO = "UPDATE_CONTACT_INFO",
    UPDATE_CONTACT = "UPDATE_CONTACT",
}

export class NominativeData extends BaseDto<NominativeInfo, NominativeData> {
    code?: string;
    businessName?: string;
    address?: Address
    vatId?: string;
    taxCode?: string;
    email?: string;
    phone?: string;
    pec?: string;
    suspended?: boolean;
    validFrom?: Date;
    validTo?: Date;
    customer?: boolean;
    customerSdiCode?: string;
    customerSuspended?: boolean;
    supplier?: boolean;
    subcontractor?: boolean;
    hasEmployee?: boolean;
    supplierSdiCode?: string;
    supplierSuspended?: boolean;

    crmId?: string;
    creditSafeId?: string;
    goUser?: string;
    personalData?: PersonalData
    state?: number;

    type?: MultiselectItem | number;
    customerPayment?: MultiselectItem | number;
    customerAdvPayment?: MultiselectItem | number;
    supplierPayment?: MultiselectItem | number;
    company?: MultiselectItem | number;

}

export class BusinessConsultant {
    name: string;
    email?: string;
    phone?: string;
}

export class NominativeInfo extends NominativeData {
    id?: number;
    businessConsultant?: BusinessConsultant;
    incompleteDocuments?: boolean;
    minExpirationDate?: Date;
    documentsCount?: number;
    companyName?: string;
    possibleActions?: PossibleActions;

    constructor() {
        super();
        this.address = {
            address: null,
            city: null,
            zipCode: null,
            province: null,
        }
        this.personalData = {sex: <MultiselectItem>{id: 0, itemName: 'Maschio'}}
    }

    get companyId(): number {
        if (isNonNullObject(this.company) && isNonNull((this.company as MultiselectItem).id))
            return (this.company as MultiselectItem).id
        else if (isNonNullNumber(this.company))
            return this.company as number
        return null;

    }

    get enabled(): boolean {
        return this.state == 1
    }

    get customerOrSupplier(): boolean {
        return this.customer || this.supplier
    }

    get personalDataStatus(): PersonalDataStatus {
        let type = this.personalData?.type
        if(!!type)
            return type
        return PersonalDataStatus.NONE
    }

    override forUi() {
        this.ensureDefaults(this)
        this.validFrom = asDate(this.validFrom)
        this.validTo = asDate(this.validTo)
        this.personalData.birthday = asDate(this.personalData.birthday)
        return this
    }

    override toRequest(config?: any): any {
        const req = super.toRequest(Object.assign(<NominativeData>{}, this),
            {
                excludes: ['personalData']
            });
        delete req['businessConsultant']
        delete req['incompleteDocuments']
        delete req['documentsCount']
        delete req['minExpirationDate']
        delete req['username']
        if (config.personalDataStatus == PersonalDataStatus.NONE)
            delete req.personalData
        else
            req.personalData.type = config.personalDataStatus
        return req
    }

    private ensureDefaults(obj: NominativeInfo) {
        if (!isNonNull(obj.address))
            obj.address = {}
        if (!isNonNull(obj.personalData))
            obj.personalData = {sex: <MultiselectItem>{id: 0, itemName: 'Maschio'}}
        return obj
    }

    static typeName(obj) {
        return isNonNullObject(obj) ? obj.itemName : null
    }

    copyFrom(source: NominativeInfo) {
        const {businessName, taxCode, vatId, email, phone, address} = source;
        this.businessName = businessName;
        this.taxCode = taxCode;
        this.vatId = vatId;
        this.email = email;
        this.phone = phone;
        this.address.address = address.address;
        this.address.city = address.city;
        this.address.zipCode = address.zipCode;
        this.address.province = address.province;
    }
}

export class NominativeListRequestBody extends ListRequestBody {
    override toRequest(): ListRequestBody {
        const req = super.toRequest()
        const account = req.filters.ACCOUNT;
        account.creationSite = isNonEmptyArray(account.creationSite) ?
            account.creationSite?.map(r => r.id) : null
        account.accountType = isNonEmptyArray(account.accountType) ?
            account.accountType?.map(r => r.id) : null
        account.company = isNonEmptyArray(account.company) ? account.company : null
        return req;
    }

    override reset() {
        const account = this.filters.ACCOUNT
        Object.keys(account).forEach(field => account[field] = null)
        account.state = State.ALL
    }
}

export class PersonalData {
    id?: number;
    name?: string;
    surname?: string;
    taxCode?: string;
    birthday?: Date;
    birthCity?: string;
    birthProvince?: string;
    birthForeign?: boolean;
    sex?: MultiselectItem | InObj | number;
    type?: PersonalDataStatus;

}

export class NominativeContact {
    id?: number;
    description?: string;
    defaultAccountContact?: false;
    telephone?: string;
    email?: string;
    smsWhatsapp?: boolean;
    mailOffers?: boolean;
    mailOrders?: false;
    mailShipments?: boolean;
    mailInvoices?: boolean;
    mailAdministration?: false;
    phoneNotifyOffers?: boolean;
    phoneNotifyOrders?: boolean;
    phoneNotifyShipments?: boolean;
    phoneNotifyInvoices?: false;
    state?: boolean;
    possibleActions?: {
        delete: false,
        edit: true,
        duplicate: false,
        toggle: true
    }

}

export class SubcontractorUpload {
    upload: Upload;
    type: number;
    expirationDate: number;
}


export enum NominativeState {
    OPEN = 0,
    CLOSED = 1,
    FORCED = 2
}

export enum PersonalDataStatus {
    NONE = "none",
    IC = "IC",
    LR = "LR"
}

export enum TaxRate {
    ALL = "all",
    PRIVATE = "private",
    COMPANY = "company",
    OTHER = "other"
}

